import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Image from 'common/src/components/Image';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';
import Particles from '../Particle';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import UIDesignWrapper, { UIDesignObject } from './uidesign.style';

import UIDesignObject1 from 'common/src/assets/image/appModern/uidesignwhite.png';

const UIDesignSection = ({
  row,
  col,
  title,
  btnStyle,
  description,
  discountText,
  discountAmount,
  outlineBtnStyle,
}) => {
  const ButtonGroup = () => (
    <Fragment>
      <AnchorLink href="#quote" offset={84}>
        <Button title="GET A QUOTE" {...btnStyle} />
      </AnchorLink>  
    </Fragment>
  );
  return (
    <UIDesignWrapper id="banner_section">
      <Particles />
      <Container>
        <Box className="row" {...row}>
          <Box className="col" {...col}>
            {/*<Heading className="subtitle" as="h5" content="APP'S DASHBOARD" /> */}
            <FeatureBlock
              title={
                <Heading
                  content="User Experience Design"
                  {...title}
                />
              }
              description={
                <Text
                  content="Innovating your UX design is more than buying a product — it’s investing in user-centric thinking as a competitive differentiator. We shape our clients’ investments with a rational view of returns, a holistic view of processes, and a deep understanding of what your customers, partners, and teams truly value."
                  {...description}
                />
              }
              button={<ButtonGroup />}
            />
          </Box>
        </Box>
      </Container>
      <UIDesignObject>
        <div className="uidesignWrapper">
          <Image src={UIDesignObject1} alt="UIDesignObject1" />
        </div>
      </UIDesignObject>
    </UIDesignWrapper>
  );
};

UIDesignSection.propTypes = {
  title: PropTypes.object,
  btnStyle: PropTypes.object,
  description: PropTypes.object,
  contentStyle: PropTypes.object,
};

UIDesignSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  col: {
    pr: '15px',
    pl: '15px',
    width: [1, '70%', '50%', '45%'],
  },
  title: {
    fontSize: ['22px', '30px', '30px', '30px', '36px'],
    fontWeight: '700',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: ['20px', '15px', '15px', '20px', '25px'],
    lineHeight: '1.3',
    maxWidth: ['100%', '400px'],
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.85',
    mb: '0',
  },
  btnStyle: {
    minWidth: ['120px', '120px', '120px', '156px'],
    fontSize: ['13px', '14px'],
    fontWeight: '500',
    colors: 'primaryWithBg',
  },
};

export default UIDesignSection;
